import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Row, Col, Input, Spin, Typography, Modal } from "antd";
// import {
//   switchQuestion,
//   updateIsMarked,
//   fetchTestdata,
//   fetchTraineeTestQuestions,
//   fetchTraineeTestAnswerSheet,
// } from "../../../actions/traineeAction";
import { switchQuestion } from "../../../reducers/trainee";
import { SecurePost } from "../../../services/axiosCall";
import apis from "../../../services/Apis";
import { retriveToken } from "../../../services/AuthServices";
import BgImage from "../../../assets/testPageBg.svg";
import CorrectImg from "../../../assets/ticksymbol.svg";
import InCorrectImg from "../../../assets/cross.svg";
import RadioImage from "../../../assets/Radio.svg";
import EditIcon from "../../../assets/editIcon.png";
import TestBoardHeader from "../examPortal/TestBoardHeader";
import "../examPortal/testBoardHeader.css";
import "../examPortal/portal.css";
import "./answer.css";

const SingleQuestionResult = ({
  testName,
  role,
  triggerSidebar,
  mode,
  isCorrect,
  data,
  testId,
  traineeid,
  totalScore,
  totalMarks,
  reFetch,
  setReFetch,
}) => {
  const trainee = useSelector((state) => state.trainee);
  const dispatch = useDispatch();

  const activeIndex = trainee?.activeQuestionIndex ?? 0;
  const activeQuestion = trainee?.questions?.[activeIndex];
  const currentAnswer = trainee?.answers?.[activeIndex];
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMarkingModalOpen, setIsMarkingModalOpen] = useState(false);
  const [questionMarks, setQuestionMarks] = useState(
    activeQuestion?.weightage ?? 0
  );
  const [isQuestion, setIsQuestion] = useState(
    currentAnswer?.givenAnswer?.[0] === currentAnswer?.correctAnswer?.[0]
  );
  const [loading, setLoading] = useState(true);
  // const [AnswerSelected, setAnswerSelected] = useState(
  //   currentAnswer?.chosenOption?.length === activeQuestion?.anscount
  // );
  const [width, setWidth] = useState(window.innerWidth);
  const [CurrentQuestions, setCurrentQuestions] = useState(data[activeIndex]);
  // console.log("Current Question", CurrentQuestions);
  // console.log("Current Answers", currentAnswer);

  const [options1] = useState([
    { id: 1, name: "Option 1" },
    { id: 2, name: "Option 2" },
    { id: 3, name: "Option 3" },
  ]);

  const [options2] = useState([
    { id: 1, name: "Option 1" },
    { id: 2, name: "Option 2" },
    { id: 3, name: "Option 3" },
  ]);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    setQuestionMarks(activeQuestion?.weightage ?? 0);
    setIsQuestion(
      currentAnswer?.givenAnswer?.[0] === currentAnswer?.correctAnswer?.[0]
    );
    // setAnswerSelected(
    //   currentAnswer?.chosenOption?.length === activeQuestion?.anscount
    // );
    setCurrentQuestions(data[activeIndex]);

    return () => window.removeEventListener("resize", handleResize);
  }, [activeQuestion, currentAnswer, activeIndex, data]);

  // Modal Handlers
  const handleOpen = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);
  const handleMarkingOpen = () => setIsMarkingModalOpen(true);
  const handleMarkingCancel = () => setIsMarkingModalOpen(false);
  const handleQuestionTrue = () => setIsQuestion(true);
  const handleQuestionFalse = () => setIsQuestion(false);

  const handleMarkingSubmit = () => {
    if (questionMarks > activeQuestion?.weightage) return;

    const token = retriveToken();
    if (token && token !== "undefined") {
      SecurePost({
        url: apis.MANUAL_MARKING,
        data: {
          userid: traineeid,
          testid: testId,
          isCorrect: isQuestion,
          qid: currentAnswer?._id,
          score: questionMarks,
        },
        params: { Token: token },
      }).then(() => {
        setReFetch((prev) => !prev);
        setIsMarkingModalOpen(false);
      });
    }
  };

  // Navigation Handlers
  const previous = () => {
    if (activeIndex > 0) {
      dispatch(switchQuestion(activeIndex - 1));
    }
  };

  const next = () => {
    setLoading(false);

    if (activeIndex >= data.length - 1) {
      dispatch(switchQuestion(0));
      // navigate(role !== "TRAINER" ? "/user/testHistory" : "/user/listtests");
    } else {
      dispatch(switchQuestion(activeIndex + 1));
    }
  };

  const indexQuestion = (qno) => {
    console.log("clicked", qno);

    dispatch(switchQuestion(qno));
  };

  // Media Type Detection
  let opts = ["A", "B", "C", "D", "E"];
  const image = activeQuestion?.quesimg?.split("www.leagueonline.sg:5000");
  const path = "https://www.leagueonline.sg:5000";
  // const path = apis.BASE_LOCAL_URL;
  const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp"];
  const videoExtensions = ["mp4", "avi", "mov", "mkv"];
  const extension = activeQuestion?.quesimg
    ? image?.[0] === "https://"
      ? image[1]?.split(".").pop()?.toLowerCase()
      : activeQuestion.quesimg.split(".").pop()?.toLowerCase()
    : "";

  return (
    <>
      {!loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Spin />
        </div>
      ) : (
        <div>
          <TestBoardHeader
            testName={testName}
            role={role}
            next={next}
            previous={previous}
            isCorrect={isCorrect}
            isFinish={trainee.activeQuestionIndex === data.length - 1}
          />

          <div
            style={{ height: "100%", overflow: "hidden" }}
            className="Question-single-container-new"
          >
            <Row className="resultParrentWrapper" style={{ display: "flex" }}>
              <Col
                className="leftColQuestionResult second"
                span={width <= 1020 ? 24 : 17}
              >
                <Row>
                  <Col className="mobileTool" span={24}>
                    {mode === "mobile" && (
                      <Button
                        onClick={triggerSidebar}
                        style={{ background: "#009999", color: "#fff" }}
                      >
                        Tool
                      </Button>
                    )}
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col span={24} style={{ fontSize: "1.2rem" }}>
                    <Typography className="marksText">
                      <span className="questionNoText">
                        Question {trainee.activeQuestionIndex + 1}
                      </span>
                      <span
                        style={{
                          color: "red",
                          fontSize: "20px",
                          marginLeft: 5,
                        }}
                      >
                        {activeQuestion?.weightage} mark(s)
                      </span>
                    </Typography>
                    <div
                      style={{ maxWidth: 650 }}
                      className="questionBody"
                      dangerouslySetInnerHTML={{
                        __html: CurrentQuestions?.body,
                      }}
                    />
                  </Col>
                </Row>

                <div className="Question-single-body-holder">
                  {CurrentQuestions?.quesimg && (
                    <div className="Single-question-body-image-container-new">
                      {imageExtensions.includes(extension) ? (
                        <img
                          src={
                            image && image[0] === "https://"
                              ? path + image[1]
                              : path + "/" + CurrentQuestions.quesimg
                          }
                          className="image-tag"
                        />
                      ) : videoExtensions.includes(extension) ? (
                        <video className="image-tag" controls>
                          <source
                            src={
                              image && image[0] === "https://"
                                ? path + image[1]
                                : path + "/" + CurrentQuestions.quesimg
                            }
                            type="video/mp4"
                          />
                        </video>
                      ) : null}
                    </div>
                  )}
                </div>

                <div className="Question-single-option-panel">
                  <Row
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "22px",
                    }}
                  >
                    {CurrentQuestions?.options?.length > 0 ? (
                      CurrentQuestions?.options.map((d, i) => (
                        <Col key={i} className="Single-option-new">
                          <Row
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 10,
                              maxWidth: "600px",
                              borderRadius: "5px",
                              paddingLeft: "10px",
                              backgroundColor:
                                opts[i] ===
                                  CurrentQuestions?.correctAnswer[0] &&
                                opts[i] === CurrentQuestions?.givenAnswer[0]
                                  ? "#37B36A33" // ✅ Correct answer selected → green
                                  : opts[i] ===
                                      CurrentQuestions?.correctAnswer[0] &&
                                    CurrentQuestions?.givenAnswer[0] !==
                                      CurrentQuestions?.correctAnswer[0]
                                  ? "#37B36A33" // ✅ Correct answer NOT selected → still show correct answer as green
                                  : opts[i] ===
                                      CurrentQuestions?.givenAnswer[0] &&
                                    CurrentQuestions?.givenAnswer[0] !==
                                      CurrentQuestions?.correctAnswer[0]
                                  ? "#FF000026" // ❌ Incorrect answer selected → red
                                  : "transparent",
                            }}
                          >
                            <Col>
                              <Typography
                                // className="questionBody"
                                style={{
                                  border: "2px solid black",
                                  width: "30px",
                                  height: "30px",
                                  borderRadius: "100%",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  fontSize: "20px",
                                }}
                              >
                                {opts[i]}
                              </Typography>
                            </Col>
                            <Col>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 10,
                                }}
                              >
                                <h3 style={{ fontSize: 20, fontWeight: 400 }}>
                                  {d.optbody}
                                </h3>
                                {d.optimg && (
                                  <div
                                    className={
                                      d.optimg
                                        ? "option-image-in-exam-panel-holder"
                                        : "option-image-in-exam-panel-holder-w0"
                                    }
                                  >
                                    <img
                                      crossOrigin="anonymous"
                                      alt="Unable to load"
                                      className="option-image-in-exam-panel"
                                      width="150px"
                                      height="150px"
                                      style={{ marginLeft: "12px" }}
                                      src={d.optimg}
                                    />
                                  </div>
                                )}
                                {opts[i] ===
                                CurrentQuestions?.correctAnswer[0] ? (
                                  <Typography className="correct-answere">
                                    {CurrentQuestions?.givenAnswer[0] ===
                                    CurrentQuestions?.correctAnswer[0]
                                      ? "(your answer)"
                                      : "(correct answer)"}
                                  </Typography>
                                ) : opts[i] ===
                                  CurrentQuestions?.givenAnswer[0] ? (
                                  CurrentQuestions?.givenAnswer[0] ===
                                  CurrentQuestions?.correctAnswer[0] ? (
                                    ""
                                  ) : (
                                    <Typography className="your-answere">
                                      (your answer)
                                    </Typography>
                                  )
                                ) : (
                                  // <img src={RadioImage} alt="" />
                                  ""
                                )}
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      ))
                    ) : (
                      <Col>
                        <Row
                          style={{
                            display: "flex",
                            alignItems: "flex-end",
                            bottom: 0,
                            gap: 4,
                          }}
                        >
                          {activeQuestion?.position === "left" && (
                            <Col>
                              <Typography
                                style={{
                                  fontWeight: "600",
                                  fontSize: "22px",
                                  textAlign: "end",
                                }}
                              >
                                {activeQuestion.unit}
                              </Typography>
                            </Col>
                          )}
                          {CurrentQuestions?.iscorrect ? (
                            <>
                              {CurrentQuestions?.isLong ? (
                                <Col span={18}>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "6px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                      }}
                                    >
                                      <Typography className="questionBody">
                                        {CurrentQuestions.correctAnswer[0]}
                                      </Typography>
                                      <Typography className="correct-answere">
                                        (model answer)
                                      </Typography>
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                      }}
                                    >
                                      <Typography className="questionBody">
                                        {CurrentQuestions.givenAnswer[0]}
                                      </Typography>
                                      <Typography className="correct-answere">
                                        (your answer)
                                      </Typography>
                                    </div>
                                  </div>
                                </Col>
                              ) : (
                                <Col span={18}>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "6px",
                                    }}
                                  >
                                    <Typography className="questionBody">
                                      {CurrentQuestions.correctAnswer[0]}
                                    </Typography>
                                    <Typography className="correct-answere">
                                      {CurrentQuestions.givenAnswer[0] ===
                                      CurrentQuestions.correctAnswer[0]
                                        ? "(your answer)"
                                        : "(correct answer)"}
                                    </Typography>
                                  </div>
                                </Col>
                              )}
                            </>
                          ) : (
                            <Col span={18}>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "4px",
                                }}
                              >
                                {CurrentQuestions &&
                                CurrentQuestions?.isLong ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "8px",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Typography className="questionBody">
                                        {CurrentQuestions.correctAnswer[0]}
                                      </Typography>
                                      <Typography className="correct-answere">
                                        (model answer)
                                      </Typography>
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "8px",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Typography className="questionBody">
                                        {CurrentQuestions.givenAnswer[0]}
                                      </Typography>
                                      <Typography className="correct-answere">
                                        (your answer)
                                      </Typography>
                                    </div>
                                  </div>
                                ) : (
                                  <>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                      }}
                                    >
                                      <Typography className="questionBody">
                                        {CurrentQuestions?.correctAnswer[0]}
                                      </Typography>
                                      <Typography className="correct-answere">
                                        (correct answer)
                                      </Typography>
                                    </div>
                                    {CurrentQuestions?.givenAnswer[0] !==
                                      CurrentQuestions?.correctAnswer[0] && (
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "6px",
                                        }}
                                      >
                                        <Typography className="questionBody">
                                          {CurrentQuestions.givenAnswer[0]}
                                        </Typography>
                                        <Typography className="your-answere">
                                          (your answer)
                                        </Typography>
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>
                            </Col>
                          )}
                          {activeQuestion?.position === "right" && (
                            <Col>
                              <Typography
                                style={{ fontWeight: "600", fontSize: "22px" }}
                              >
                                {activeQuestion.unit}
                              </Typography>
                            </Col>
                          )}
                        </Row>
                      </Col>
                    )}
                  </Row>
                </div>
                <div style={{ marginTop: "20px" }}>
                  {CurrentQuestions?.explanation && (
                    <Typography
                      style={{
                        fontWeight: 600,
                        fontSize: "22px",
                      }}
                    >
                      {"Explanation:"}
                    </Typography>
                  )}
                  {CurrentQuestions?.explanation && (
                    <div
                      className="explanationModal"
                      style={{ maxWidth: 600 }}
                      dangerouslySetInnerHTML={{
                        __html: CurrentQuestions?.explanation || "",
                      }}
                    />
                  )}
                </div>
              </Col>

              <Col className="first" span={width <= 1020 ? 24 : 7}>
                <div className="SiderQuestionResult">
                  <div
                    style={{
                      height: "100%",
                      maxHeight: "auto",
                      overflowY: "auto",
                      overflowX: "hidden",
                      padding: "10px",
                    }}
                  >
                    <Typography
                      style={{ textAlign: "center", paddingBottom: "10px" }}
                      className="questionAnsTitle"
                    >
                      {data.find(
                        (item) =>
                          !item.isMarked && item.hasOwnProperty("isMarked")
                      )
                        ? "Final Score: Pending"
                        : ""}
                    </Typography>
                    <Row className="marksContainer">
                      <Col span={12}>
                        <Typography className="marksTitleO">
                          Your Score:
                        </Typography>
                      </Col>
                      <Col span={12}>
                        <Typography className="marksTitleT">Total:</Typography>
                      </Col>
                      <Col span={12}>
                        <Typography className="marksO">{totalScore}</Typography>
                      </Col>
                      <Col span={12}>
                        <Typography className="marksT">{totalMarks}</Typography>
                      </Col>
                    </Row>

                    <Row style={{ display: "flex", flexDirection: "column" }}>
                      <Row
                        gutter={[16, 16]}
                        style={{ padding: "5px", display: "flex", gap: 20 }}
                      >
                        <Col className="questionAnsTitle">
                          <Typography>Question No.</Typography>
                        </Col>
                        <Col className="questionAnsTitle">
                          <Typography>Status</Typography>
                        </Col>
                      </Row>
                      {data?.map((item, index) => (
                        <React.Fragment key={index}>
                          {item.iscorrect ? (
                            <Row
                              style={{
                                padding: "0px 5px",
                                borderBottom: "2px solid #B4B4B4",
                              }}
                            >
                              <Col
                                span={12}
                                style={{ cursor: "pointer" }}
                                className="questionAns"
                              >
                                <Typography
                                  style={{
                                    fontWeight:
                                      trainee.activeQuestionIndex === index
                                        ? 900
                                        : 600,
                                    cursor: "pointer",
                                    position: "relative",
                                    zIndex: 9999,
                                  }}
                                  onClick={() => indexQuestion(index)}
                                >
                                  {index + 1}
                                </Typography>
                              </Col>
                              <Col span={12}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                >
                                  <Typography className="questionAns">
                                    {item.iscorrect
                                      ? "Correct"
                                      : !item.isMarked && item.isLong
                                      ? "pending"
                                      : "Incorrect"}
                                  </Typography>
                                  <img
                                    width="10%"
                                    src={
                                      item.iscorrect
                                        ? CorrectImg
                                        : !item.isMarked && item.isLong
                                        ? ""
                                        : InCorrectImg
                                    }
                                    alt=""
                                  />
                                </div>
                              </Col>
                            </Row>
                          ) : (
                            !item.iscorrect && (
                              <Row
                                style={{
                                  padding: "0px 5px",
                                  borderBottom: "2px solid #B4B4B4",
                                }}
                              >
                                <Col
                                  span={12}
                                  style={{ cursor: "pointer" }}
                                  className="questionAns"
                                >
                                  <Typography
                                    style={{
                                      fontWeight:
                                        trainee.activeQuestionIndex === index
                                          ? 900
                                          : 600,
                                      cursor: "pointer",
                                      position: "relative",
                                      zIndex: 9999,
                                    }}
                                    onClick={() => indexQuestion(index)}
                                  >
                                    {index + 1}
                                  </Typography>
                                </Col>
                                <Col className="questionAns" span={12}>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "4px",
                                    }}
                                  >
                                    <Typography>
                                      {item.iscorrect
                                        ? "Correct"
                                        : !item.isMarked && item.isLong
                                        ? "pending"
                                        : "Incorrect"}
                                    </Typography>
                                    <img
                                      width="10%"
                                      src={
                                        item.iscorrect
                                          ? CorrectImg
                                          : !item.isMarked && item.isLong
                                          ? ""
                                          : InCorrectImg
                                      }
                                      alt=""
                                    />
                                  </div>
                                </Col>
                              </Row>
                            )
                          )}
                        </React.Fragment>
                      ))}
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>

            <div className="ImagebgTest">
              <img src={BgImage} alt="" />
            </div>

            {role !== "TRAINER"
              ? CurrentQuestions?.explanation && (
                  <div className="explanationText">
                    <Typography
                      style={{
                        textDecoration: "underline",
                        fontWeight: 700,
                        color: "#0049D8",
                        fontSize: "22px",
                      }}
                      onClick={handleOpen}
                    >
                      View Explanation
                    </Typography>
                  </div>
                )
              : !CurrentQuestions?.isMarked && (
                  <div className="editButton">
                    <div
                      style={{
                        backgroundColor: isMarkingModalOpen
                          ? "#C5C5C5"
                          : "#0082FB",
                      }}
                      className="editBox"
                      onClick={handleMarkingOpen}
                    >
                      <img width="35px" height="35px" src={EditIcon} alt="" />
                    </div>
                  </div>
                )}
          </div>
          <br />

          <Modal
            open={isModalOpen}
            footer={null}
            closable={false}
            centered
            onCancel={handleCancel}
            width={350}
            className="explanationModal"
            style={{
              borderRadius: "25px",
              backgroundColor: "#D9D9D9",
              color: "black",
            }}
          >
            <div
              className="explanationModal"
              dangerouslySetInnerHTML={{
                __html: CurrentQuestions?.explanation || "",
              }}
            />
          </Modal>

          <Modal
            open={isMarkingModalOpen}
            footer={null}
            closable={false}
            onCancel={handleMarkingCancel}
            width={350}
            className="explanationModal"
            style={{ top: "50%", borderRadius: "25px" }}
          >
            <div className="MarkingModalBox">
              <Typography className="markingTitle">Edit Marking</Typography>
              <Typography style={{ width: "100%" }} className="markingPara">
                current question marks {activeQuestion?.weightage}
              </Typography>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography style={{ width: "80%" }} className="markingPara">
                  enter new question marks
                </Typography>
                <Input
                  min={0}
                  max={activeQuestion?.weightage}
                  type="number"
                  value={questionMarks}
                  name="answer"
                  className="ansInput"
                  style={{ width: "20%", backgroundColor: "white" }}
                  onChange={(e) => setQuestionMarks(e.target.value)}
                  required
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography className="markingPara">Grading</Typography>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "2px" }}
                >
                  <Typography
                    style={{ color: isQuestion ? "#00C51F" : "#8F8F8F" }}
                    onClick={handleQuestionTrue}
                    className="textToggele"
                  >
                    CORRECT
                  </Typography>
                  <Typography style={{ color: "#000" }} className="textToggele">
                    /
                  </Typography>
                  <Typography
                    style={{
                      color: !isQuestion ? "#FF0D0D" : "#8F8F8F",
                      cursor: "pointer",
                    }}
                    onClick={handleQuestionFalse}
                    className="textToggele"
                  >
                    WRONG
                  </Typography>
                </div>
              </div>
              <Button
                style={{ borderRadius: "30px", marginTop: "40px" }}
                className="testHeaderButton"
                type="primary"
                onClick={handleMarkingSubmit}
              >
                Submit
              </Button>
            </div>
          </Modal>
        </div>
      )}
    </>
  );
};

export default SingleQuestionResult;
